import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-CheckShape",
  "use": "svg-icon-CheckShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg-icon-CheckShape\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M4.756 12.994a.875.875 0 0 0 1.238 0l8.75-8.75a.875.875 0 1 0-1.238-1.238L5.373 11.15l-2.88-2.894a.875.875 0 1 0-1.237 1.238l3.5 3.5z\" fill=\"#FFF\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol